import { PayloadAction } from "@reduxjs/toolkit";
import { ChatState, DraftMessageListItem } from "../chat-state";

export function appendDraftMessageInternalReducer (state : ChatState, action: PayloadAction<DraftMessageListItem>) {
  if (!state.selectedChatroomMessages?.messagesList) {
    return;
  }
  const list = state.selectedChatroomMessages.messagesList;
  list.push(action.payload);
}